import { Settings, CheckCircle } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSettingCredentials } from "../../redux/authRedux";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { hash } from "../../utils/hash";
import { SUPER_ADMIN_EMAIL, SUPER_ADMIN_HASHED_PASSWORD } from "../../config/constants";
import Swal from "sweetalert2";

export default function HeaderName({ setIsSidebarOpen, isSidebarOpen }) {
  const { settingEmail, settingPassword } = useSelector((state) => state.auth);
  const [hide, setHide] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const divStyles1 = {
    textShadow: "1px 1px 2px grey",
    margin: "auto 200px",
  };

  const handleHide = () => {
    setHide(!hide);
  };
  const Role = localStorage.getItem("role");

  const handleSettingLogin = async (e) => {
    e.preventDefault();

    if (SUPER_ADMIN_EMAIL !== email || SUPER_ADMIN_HASHED_PASSWORD !== (await hash(password))) {
      Swal.fire({
        icon: "error",
        title: "Invalid Credentials",
        toast: true,
        position: "top-end",
        timer: 3000,
        showConfirmButton: false,
      });
      return;
    }
    dispatch(setSettingCredentials({ email, password }));
    setModalOpen(false);
    setEmail("");
    setPassword("");
    navigate("/super-admin/setting");
  };

  useEffect(() => {
    async function checkLoggedin() {
      if (
        settingEmail === SUPER_ADMIN_EMAIL &&
        (await hash(settingPassword)) === SUPER_ADMIN_HASHED_PASSWORD
      ) {
        setIsAdminLoggedIn(true);
      } else {
        setIsAdminLoggedIn(false);
      }
    }
    checkLoggedin();
  }, [settingEmail, settingPassword]);

  return (
    <nav className="navbar navbar-expand navbar-white navbar-light">
      <div className="flex col-1 rounded">
        {!isSidebarOpen && (
          <button
            onClick={() => setIsSidebarOpen(true)}
            className="btn btn-link p-2 ms-3 text-dark"
          >
            <i className="fas fa-align-left fs-5"></i>
          </button>
        )}
      </div>
      {Role === "stockController" ? (
        <div className="title py-3">
          <h3 className={isSidebarOpen ? "header-title" : "header-title-close"}>
            Stock Controller
          </h3>
        </div>
      ) : (
        <div className="title py-3 ">
          <h3 className={isSidebarOpen ? "header-title" : "header-title-close"}>
            Finance & Admin Module
          </h3>
        </div>
      )}
      <div className="d-flex ms-auto align-items-center me-3">
        <Settings
          style={{ width: "20px", height: "20px", cursor: "pointer" }}
          onClick={() => setModalOpen(true)}
        />
      </div>
      {/* Setting Login Modal */}

      {modalOpen && (
        <>
          <div
            className="modal-backdrop fade show"
            onClick={() => setModalOpen(false)}
          ></div>
          <div className="modal d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
              {isAdminLoggedIn ? (
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Already Logged In</h5>
                    <button
                      type="button"
                      className="close"
                      onClick={() => setModalOpen(false)}
                    >
                      <span>&times;</span>
                    </button>
                  </div>
                  <div className="modal-body text-center py-4">
                    <div className="mb-2">
                      <CheckCircle size={48} className="text-success" />
                    </div>
                    <h5 className="fw-bold mb-0">You are already logged in.</h5>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setModalOpen(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              ) : (
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Setting Login</h5>
                    <button
                      type="button"
                      className="close"
                      onClick={() => setModalOpen(false)}
                    >
                      <span>&times;</span>
                    </button>
                  </div>
                  <form onSubmit={handleSettingLogin}>
                    <div className="modal-body">
                      <FormControl
                        sx={{ m: 1, width: "100%" }}
                        variant="outlined"
                      >
                        <InputLabel htmlFor="setting-email">Email</InputLabel>
                        <OutlinedInput
                          id="setting-email"
                          type="email"
                          label="Email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </FormControl>
                      <FormControl
                        sx={{ m: 1, width: "100%" }}
                        variant="outlined"
                      >
                        <InputLabel htmlFor="setting-password">
                          Password
                        </InputLabel>
                        <OutlinedInput
                          id="setting-password"
                          type={showPassword ? "text" : "password"}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => setShowPassword((s) => !s)}
                                edge="end"
                              >
                                {showPassword ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                          label="Password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                        />
                      </FormControl>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setModalOpen(false)}
                      >
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Login
                      </button>
                    </div>
                  </form>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </nav>
  );
}
